
/**
 * @fileoverview Serviço de Logging centralizado para o Frontend.
 * 
 * Este módulo fornece uma interface de logging simples (info, warn, error)
 * que pode ser usada em toda a aplicação. Em ambiente de desenvolvimento,
 * ele simplesmente usa o console do navegador. Em produção, ele pode ser
 * estendido para enviar logs para um serviço de monitoramento externo
 * (como Sentry, LogRocket, etc.) sem alterar o código que o consome.
 */

const LOG_LEVEL = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
};

// Define o nível de log atual. Em produção, isso viria de uma variável de ambiente.
const currentLogLevel = process.env.NODE_ENV === 'production' ? LOG_LEVEL.WARN : LOG_LEVEL.DEBUG;

const log = (level, message, ...optionalParams) => {
  if (level < currentLogLevel) {
    return;
  }

  const timestamp = new Date().toISOString();
  const formattedMessage = `[${timestamp}] [${Object.keys(LOG_LEVEL).find(key => LOG_LEVEL[key] === level)}] ${message}`;

  // Em um cenário de produção, aqui você enviaria o log para um serviço externo.
  // if (process.env.NODE_ENV === 'production') {
  //   myMonitoringService.log(formattedMessage, ...optionalParams);
  // }

  // Em desenvolvimento, usamos o console.
  switch (level) {
    case LOG_LEVEL.DEBUG:
      console.debug(formattedMessage, ...optionalParams);
      break;
    case LOG_LEVEL.INFO:
      console.info(formattedMessage, ...optionalParams);
      break;
    case LOG_LEVEL.WARN:
      console.warn(formattedMessage, ...optionalParams);
      break;
    case LOG_LEVEL.ERROR:
      console.error(formattedMessage, ...optionalParams);
      break;
    default:
      console.log(formattedMessage, ...optionalParams);
  }
};

export const logger = {
  debug: (message, ...optionalParams) => log(LOG_LEVEL.DEBUG, message, ...optionalParams),
  info: (message, ...optionalParams) => log(LOG_LEVEL.INFO, message, ...optionalParams),
  warn: (message, ...optionalParams) => log(LOG_LEVEL.WARN, message, ...optionalParams),
  error: (message, ...optionalParams) => log(LOG_LEVEL.ERROR, message, ...optionalParams),
};
